import { Container } from '@material-ui/core'
import { InfoOutlined } from '@material-ui/icons'

import AlertDialog from '@/components/alert-dialog'

import { MainContent } from './components/main-content'
import { Menu } from './components/menu'
import { ProjectProvider, useProject } from './contexts/project-context'
import { useStyles } from './styles'

function ProjectFormComponent() {
  const classes = useStyles()
  const {
    form: { handleSubmit },
    context: {
      handleForm,
      activeStep,
      isAlertModalOpen,
      closeAlertModal,
      errorMutation,
      isFetchingGetProject,
    },
  } = useProject()

  function getAlertProps() {
    if (errorMutation?.response?.status === 409) {
      return {
        icon: <InfoOutlined />,
        title: 'Ocorreu um erro',
        subtitle: 'Não foi possível cadastrar o projeto',
        items: [
          <>
            <strong>O nome do projeto já existe.</strong> Por favor, altere o
            nome do projeto ou edite o projeto existente.
          </>,
          'Se o problema persistir, entre em contato com o suporte.',
        ],
        variant: 'error' as const,
        confirm: 'Ok, entendi',
        handleConfirm: closeAlertModal,
      }
    }
    return {
      icon: <InfoOutlined />,
      title: 'Ocorreu um erro',
      subtitle: 'Não foi possível cadastrar o projeto',
      items: [errorMutation?.message || ''],
      variant: 'error' as const,
      confirm: 'Ok, entendi',
      handleConfirm: closeAlertModal,
    }
  }

  function preventSubmit(e: React.KeyboardEvent) {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }

  return (
    <>
      <div className={classes.container}>
        <Menu />

        <Container
          maxWidth='lg'
          disableGutters
          component='form'
          noValidate
          onSubmit={handleSubmit(handleForm)}
          onKeyDown={preventSubmit}
        >
          <MainContent
            activeStep={activeStep}
            isLoading={isFetchingGetProject}
          />
        </Container>
      </div>

      <AlertDialog {...getAlertProps()} open={isAlertModalOpen} />
    </>
  )
}

const ProjectsForm = () => {
  return (
    <ProjectProvider>
      <ProjectFormComponent />
    </ProjectProvider>
  )
}

export default ProjectsForm
